import { RecoverUsernameForm } from 'pages/authentication/recover_username/components/RecoverUsernameForm';
import { LoginFooter } from 'pages/authentication/login';
import { useNavigate } from 'react-router-dom';
import { AuthApi } from 'apis/AuthApi';
import { useSuperState } from 'hooks';
import { useIntl } from 'react-intl';

import 'pages/authentication/login/styles/Login.scss';

export const RecoverUsername = () => {

    const { formatMessage } = useIntl();

    const [state, setState] = useSuperState({
        error: '',
        loading: false,
        showSuccess: false,
        successMessage: ''
    });

    const { error, loading, showSuccess, successMessage } = state;

    const navigate = useNavigate();

    const handleSubmit = async (email: string) => {

        try {

            setState({ error: '', loading: true });
            await AuthApi.RecoverUsername(email);
            setState({
                loading: false,
                showSuccess: true,
                successMessage: formatMessage({ id: 'thank_you_an_email_will_be_sent_containi.edb07a06', defaultMessage: 'Thank you! An email will be sent containing your username if one exists. If you do not see the email, please be sure to check your spam folder.' }) || 'Thank you! An email will be sent containing your username if one exists. If you do not see the email, please be sure to check your spam folder.'
            });

        } catch {

            setState({ loading: false });

        }

    };

    const buildNumber = document.getElementById('root')?.dataset.build || '';

    return (
        <div className="login-page">
            <div className="login-form-panel d-flex flex-column position-relative bg-transparent">
                {showSuccess && (
                    <div className="login-success-banner w-100 mx-auto mb-3 d-flex align-items-start gap-3">
                        <i className="fa-solid fa-circle-check login-success-icon flex-shrink-0" />
                        <span className="login-success-body flex-grow-1">
                            {successMessage}
                        </span>
                        <button
                            className="login-success-dismiss"
                            onClick={() => setState({ showSuccess: false, successMessage: '' })}
                            type="button"
                        >
                            <i className="fa-solid fa-xmark" />
                        </button>
                    </div>
                )}

                {error && (
                    <div className="login-error-banner w-100 mx-auto mb-3 d-flex align-items-start gap-3">
                        <i className="fa-solid fa-circle-exclamation login-error-icon flex-shrink-0" />
                        <span className="login-error-body flex-grow-1">
                            {error}
                        </span>
                    </div>
                )}

                <div className="login-form-container d-flex flex-column align-items-center">
                    <div className="login-card w-100 bg-white">
                        <RecoverUsernameForm
                            loading={loading}
                            onBack={() => navigate('/login')}
                            onError={msg => setState({ error: msg })}
                            onSubmit={handleSubmit}
                        />
                    </div>
                </div>

                <LoginFooter buildNumber={buildNumber} />
            </div>
        </div>
    );

};
